import { memo, useEffect, useState } from 'react';

import styles from '../../styles.module.less';

interface SearchResultAvatarProps {
  photoURL?: string | null;
  initials: string;
}

const SearchResultAvatar = memo(({ photoURL, initials }: SearchResultAvatarProps) => {
  const [hasImageError, setHasImageError] = useState(false);

  useEffect(() => {
    setHasImageError(false);
  }, [photoURL]);

  return photoURL && !hasImageError ? (
    <img
      alt=""
      className={styles.searchResultAvatar}
      onError={() => setHasImageError(true)}
      src={photoURL}
    />
  ) : (
    <span className={styles.searchResultAvatar}>{initials}</span>
  );
});

export default SearchResultAvatar;
